import { render, staticRenderFns } from "./deductionSource.vue?vue&type=template&id=5d6efc19&scoped=true&"
import script from "./deductionSource.vue?vue&type=script&lang=js&"
export * from "./deductionSource.vue?vue&type=script&lang=js&"
import style0 from "./deductionSource.vue?vue&type=style&index=0&id=5d6efc19&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6efc19",
  null
  
)

export default component.exports